// extracted by mini-css-extract-plugin
export default {"chipsBox":"index_chipsBox_-KjLF","chips":"index_chips_FMcwZ"};